/**
 * Device Unlock API Contracts
 * Centralized endpoint definitions for all device unlock related APIs
 */

// < ----------------------- SERVER APIS - START ----------------------------->

// Device Status Check APIs
export const DEVICE_UNLOCK_HOME_API = '/device-unlock/home';
export const DEVICE_UNLOCK_CHECK_API = '/device-unlock/check';

// Device Status APIs (brand-specific endpoints)
export const DEVICE_UNLOCK_LOCKED_STRAIGHTTALK_API = '/device-unlock/status/locked';
export const DEVICE_UNLOCK_LOCKED_TRACFONE_API = '/device-unlock/status/locked';
export const DEVICE_UNLOCK_LOCKED_TOTAL_WIRELESS_API = '/device-unlock/status/locked';
export const DEVICE_UNLOCK_LOCKED_SIMPLEMOBILE_API = '/device-unlock/status/locked';

export const DEVICE_UNLOCK_UNLOCKED_STRAIGHTTALK_API = '/device-unlock/status/unlocked';
export const DEVICE_UNLOCK_UNLOCKED_TRACFONE_API = '/device-unlock/status/unlocked';
export const DEVICE_UNLOCK_UNLOCKED_TOTAL_WIRELESS_API = '/device-unlock/status/unlocked';
export const DEVICE_UNLOCK_UNLOCKED_SIMPLEMOBILE_API = '/device-unlock/status/unlocked';

export const DEVICE_UNLOCK_ELIGIBLE_STRAIGHTTALK_API = '/device-unlock/status/eligible';
export const DEVICE_UNLOCK_ELIGIBLE_TRACFONE_API = '/device-unlock/status/eligible';
export const DEVICE_UNLOCK_ELIGIBLE_TOTAL_WIRELESS_API = '/device-unlock/status/eligible';
export const DEVICE_UNLOCK_ELIGIBLE_SIMPLEMOBILE_API = '/device-unlock/status/eligible';

export const DEVICE_UNLOCK_INELIGIBLE_STRAIGHTTALK_API = '/device-unlock/status/ineligible';
export const DEVICE_UNLOCK_INELIGIBLE_TRACFONE_API = '/device-unlock/status/ineligible';
export const DEVICE_UNLOCK_INELIGIBLE_TOTAL_WIRELESS_API = '/device-unlock/status/ineligible';
export const DEVICE_UNLOCK_INELIGIBLE_SIMPLEMOBILE_API = '/device-unlock/status/ineligible';

// Device Unlock Request APIs
export const DEVICE_UNLOCK_SUBMIT_STRAIGHTTALK_API = '/device-unlock/submit';
export const DEVICE_UNLOCK_SUBMIT_TRACFONE_API = '/device-unlock/submit';
export const DEVICE_UNLOCK_SUBMIT_TOTAL_WIRELESS_API = '/device-unlock/submit';
export const DEVICE_UNLOCK_SUBMIT_SIMPLEMOBILE_API = '/device-unlock/submit';

export const DEVICE_UNLOCK_ORDER_SUMMARY_STRAIGHTTALK_API = '/device-unlock/order-summary';
export const DEVICE_UNLOCK_ORDER_SUMMARY_TRACFONE_API = '/device-unlock/order-summary';
export const DEVICE_UNLOCK_ORDER_SUMMARY_TOTAL_WIRELESS_API = '/device-unlock/order-summary';
export const DEVICE_UNLOCK_ORDER_SUMMARY_SIMPLEMOBILE_API = '/device-unlock/order-summary';

// SOE Health Check
export const SOE_HEALTH_CHECK_API = '/soe/health';
export const SOE_ELIGIBILITY_CHECK_API = '/soe/device-unlock/eligibility';

// < ----------------------- SERVER APIS - END ----------------------------->

// < ----------------------- CLIENT APIS - START ----------------------------->

// Mock APIs for development/testing
export const DEVICE_UNLOCK_HOME_API_CLIENT = '/api/mock/device-unlock/home';
export const DEVICE_UNLOCK_LOCKED_API_CLIENT = '/api/mock/device-unlock/locked';
export const DEVICE_UNLOCK_UNLOCKED_API_CLIENT = '/api/mock/device-unlock/unlocked';
export const DEVICE_UNLOCK_ELIGIBLE_API_CLIENT = '/api/mock/device-unlock/eligible';
export const DEVICE_UNLOCK_INELIGIBLE_API_CLIENT = '/api/mock/device-unlock/ineligible';
export const DEVICE_UNLOCK_SUBMIT_API_CLIENT = '/api/mock/device-unlock/submit';
export const DEVICE_UNLOCK_ORDER_SUMMARY_API_CLIENT = '/api/device-unlock/order-summary';

// < ----------------------- CLIENT APIS - END ------------------------------>